import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { PoListComponent } from './list/po-list.component';
import { PoDetailsComponent } from './details/po-details.component';
import { OrderListSummaryComponent } from './list-summary/order-list-summary.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: PoListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'order.read'
            }
          }
        ]
      },
      {
        path: 'po-summary',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: OrderListSummaryComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'order.read'
            }
          }
        ]
      },
      {
        path: 'details/:id',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Detail Order'
        },
        children: [
          {
            path: '',
            component: PoDetailsComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'order.read'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoRoutingModule {}
